import { fromPromise } from 'xstate';
import { apolloClient } from '@/lib/apollo';
import {
  EnterFilingFactsMutation,
  OpenFilingMutation,
  RequestCalculationMutation,
} from '@/lib/gql/__generated__/canonical-documents';
import type { EnterFilingFactsInput, OpenFilingInput, RequestCalculationInput } from '@/lib/gql/__generated__/graphql';

function apiMessage(error: { message?: string | null } | null | undefined): string {
  return error?.message || 'The Filing service could not complete that request.';
}

function requireSuccess(success: boolean, error: { message?: string | null } | null | undefined): void {
  if (!success) throw new Error(apiMessage(error));
}

export const openFilingActor = fromPromise<
  { filingId: string; clientId: string; rulePackageId: string },
  Omit<OpenFilingInput, 'filingId'>
>(async ({ input }) => {
  const filingId = crypto.randomUUID();
  const result = await apolloClient.mutate({
    mutation: OpenFilingMutation,
    variables: {
      input: {
        clientId: input.clientId,
        filingId,
        rulePackageId: input.rulePackageId,
      },
    },
  });
  requireSuccess(result.data?.openFiling.success ?? false, result.data?.openFiling.error);
  return { ...input, filingId };
});

export const enterFilingFactsActor = fromPromise<null, EnterFilingFactsInput>(async ({ input }) => {
  const result = await apolloClient.mutate({
    mutation: EnterFilingFactsMutation,
    variables: {
      input: {
        distributions: input.distributions,
        fiduciaryFees: input.fiduciaryFees,
        filingId: input.filingId,
        mustDistributeIncome: input.mustDistributeIncome,
      },
    },
  });
  requireSuccess(result.data?.enterFilingFacts.success ?? false, result.data?.enterFilingFacts.error);
  return null;
});

export const requestCalculationActor = fromPromise<null, RequestCalculationInput>(async ({ input }) => {
  const result = await apolloClient.mutate({
    mutation: RequestCalculationMutation,
    variables: { input: { filingId: input.filingId } },
  });
  requireSuccess(result.data?.requestCalculation.success ?? false, result.data?.requestCalculation.error);
  return null;
});
